import { lazy } from 'react';
import { Wrench } from 'lucide-react';
import type { FeatureSection } from '@/app/registry';

/** Maintenance: work orders and their tasks, mechanics, and the inventory catalog and stock. */
export const maintenanceSection: FeatureSection = {
  key: 'maintenance',
  title: 'maintenance',
  icon: Wrench,
  routes: [
    {
      path: '/maintenance/work-orders',
      title: 'workOrders',
      tabs: [
        { key: 'orders', title: 'workOrders', resource: 'work_order', component: lazy(() => import('./work-orders/WorkOrdersPage')) },
        { key: 'tasks', title: 'tasks', resource: 'work_order', legacyPath: '/maintenance/tasks', component: lazy(() => import('./tasks/TasksPage')) },
      ],
    },
    { path: '/maintenance/assets', title: 'assets', resource: 'inventory.asset', component: lazy(() => import('./assets/AssetsPage')) },
    { path: '/maintenance/mechanics', title: 'mechanics', resource: 'mech', component: lazy(() => import('./mechanics/MechanicsPage')) },
    {
      path: '/maintenance/inventory',
      title: 'inventory',
      movedTabs: { assets: '/maintenance/assets' },
      tabs: [
        { key: 'stock', title: 'stock', resource: 'inventory.part', component: lazy(() => import('./inventory/InventoryPage').then((m) => ({ default: m.Stock }))) },
        { key: 'transits', title: 'transits', resource: 'inventory.part.transit', component: lazy(() => import('./inventory/InventoryPage').then((m) => ({ default: m.Transits }))) },
        { key: 'models', title: 'models', resource: 'inventory.model', legacyPath: '/maintenance/models', component: lazy(() => import('./models/ModelsPage')) },
        { key: 'parts', title: 'partCatalog', resource: 'inventory.part.spec', legacyPath: '/maintenance/parts', component: lazy(() => import('./parts/PartsPage')) },
      ],
    },
  ],
};
